exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._8g9-W{position:relative;overflow:hidden;display:inline-block}._8g9-W input[type=file]{cursor:pointer;left:0;top:0;opacity:0}._8g9-W input[type=file],._36zKP{position:absolute;width:100px;height:100px}._36zKP{left:25px;top:20px;visibility:hidden;font-size:3em}._8g9-W:hover ._36zKP{visibility:visible}.vQWMo{width:100px;height:100px;z-index:-1}.vQWMo img{position:absolute;margin:auto;top:0;left:0;right:0;bottom:0}._8g9-W:hover .vQWMo{opacity:.2}._1zONk{padding:0 0 10px}._3GESu{margin:0 15px}._3GESu,.N-HoC{display:-webkit-box;display:-ms-flexbox;display:flex}.N-HoC{margin-right:10px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
exports.locals = {
	"uploadButtonWrapper": "_8g9-W",
	"glyphWrapper": "_36zKP",
	"imageOverlay": "vQWMo",
	"formComponent": "_1zONk",
	"errorMessage": "_3GESu",
	"alertIcon": "N-HoC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/components/Image/Image.css
// module id = 1153
// module chunks = 2 3 4 5